export default __webpack_public_path__ + "static/media/penyesuaian2.21d7305c.png";